import React, { useEffect, useState } from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// utils
import { getCampaignData } from '../../utils/campaignDataEngine';
import { getAllQueryParams } from '../../../../utils/getNmTalentCareersLinks/getNmTalentCareersLinks';
// styles
import { HeroSectionStyled } from './styles';

const data = getCampaignData();

export default ({ careersFormLink }) => {
  const [queryParams, setQueryParams] = useState(false);

  useEffect(() => {
    const res = getAllQueryParams();
    setQueryParams(res);
  }, []);

  return (
    <HeroSectionStyled
      sectionId='recruitment-campaign-hero'
      campaignName={data.campaignName}
      productName='Financial Advisor Careers' // visually hidden
      headingText={<>Make a career move that changes <WidowBlock>the game.</WidowBlock></>}
      descriptionText={<>For yourself. For your family. For your community. See how becoming a Northwestern Mutual financial advisor gives your professional skills new purpose and offers game&#45;changing benefits.</>}
      ctaPrimary={{
        linkUrl: careersFormLink + queryParams,
        buttonText: 'Apply today',
        ariaLabel: 'Apply for a career with Northwestern Mutual',
        children: '',
      }}
      backgroundImageAriaLabel={data.heroSection.heroImageAltText}
      backgroundImageDesktop={data.heroSection.desktopImageWebp}
      backgroundImageMobile={data.heroSection.mobileImageWebp}
      backgroundImageDesktopLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundImageMobileLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
